import script from "./DualRangeSlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./DualRangeSlider.vue?vue&type=script&setup=true&lang=ts"

import "./DualRangeSlider.vue?vue&type=style&index=0&id=ea0e1c44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea0e1c44"]])

export default __exports__